$(document).ready(function(){

	// -- search --
	$('.btn--search').on('click', function(){
		$('body').removeClass('mainMenuMobile--open');
		$('.mainMenuTrigger .hamburger').removeClass('is-active');
		$('body').toggleClass('searchMenu--open');
		if ($('body').hasClass('searchMenu--open')) {
			$('input[name="q"]').focus();
		}
	});

	$('.searchMenu .btn--close').on('click', function(){
		$('body').removeClass('searchMenu--open');
	});

	// -- search results --
	$('.btn--website').on('click', function(){
		if (!$('.filters .btn--website').hasClass('active')) {
			$('.filters .btn--website, .results__website').addClass('active');
			$('.filters .btn--ecoinform, .results__ecoinform').removeClass('active');
		}
	});

	$('.btn--ecoinform').on('click', function(){
		if (!$('.filters .btn--ecoinform').hasClass('active')) {
			$('.filters .btn--website, .results__website').removeClass('active');
			$('.filters .btn--ecoinform, .results__ecoinform').addClass('active');
		}
	});

});